export default __webpack_public_path__ + "static/media/Q10_3_resized.8a8c8bec.jpg";